module.exports = __webpack_public_path__ + "img/bg_768.f5b38cf9.png";